<template>
  <div class="container">
    <loading-component v-if="isLoading" />
    <no-result-component
      v-else-if="computedContestants == null || computedContestants.length <= 0"
    />
    <div v-else>
      <page-title-component title="Brew list" :subtitle="competition.name" />
      <section class="section">
        <div class="container" style="max-width:420px !important;">
          <div class="control" style="margin-bottom:15px;">
            <b-switch v-model="onlyCompetitionEntries">Show competition entries only</b-switch>
          </div>
          <div class="control" style="margin-bottom:15px;">
            <b-dropdown v-model="sortByClass" aria-role="list">
              <button class="button is-primary" type="button" slot="trigger">
                <template v-if="sortByClass">
                  <b-icon icon="beer"></b-icon>
                  <span>Sort by competition class</span>
                </template>
                <template v-else>
                  <b-icon icon="account-outline"></b-icon>
                  <span>Sort by brewer</span>
                </template>
                <b-icon icon="menu-down"></b-icon>
              </button>

              <b-dropdown-item :value="true" aria-role="listitem">
                <div class="media">
                  <b-icon class="media-left" icon="beer"></b-icon>
                  <div class="media-content">
                    <h3>Sort by competition class</h3>
                    <small>One class at a time...</small>
                  </div>
                </div>
              </b-dropdown-item>

              <b-dropdown-item :value="false" aria-role="listitem">
                <div class="media">
                  <b-icon class="media-left" icon="account-outline"></b-icon>
                  <div class="media-content">
                    <h3>Sort by brewer</h3>
                    <small>List all beers per brewer...</small>
                  </div>
                </div>
              </b-dropdown-item>
            </b-dropdown>
          </div>

          <div v-for="brew in computedContestants" :key="brew.id">
            <div>
              <div class="brew-card clearfix">
                <div class="brew-card-header row clearfix">
                  <div class="alignleft">
                    <div class="brew-card-header-title">
                      <p>
                        <strong>{{brew.title}}</strong>
                      </p>
                    </div>
                  </div>
                  <div class="alignright">
                    <div
                      class="brew-card-header-class"
                      :class="getClassClass(brew.competitionClassId)"
                    >
                      <p>&nbsp;{{getClassLabel(brew.competitionClassId)}}</p>
                    </div>
                  </div>
                </div>

                <div class="brew-card-body">
                  <div class="row clearfix">
                    <div class="alignleft">
                      <p>{{brew.brewer}}</p>
                    </div>
                    <div class="alignright">
                      <p style="text-align:right;">&nbsp;</p>
                    </div>
                  </div>

                  <div class="row clearfix">
                    <div class="alignleft">
                      <p>
                        <i>{{brew.style}}</i>
                      </p>
                    </div>
                    <div class="alignright">
                      <p>
                        <i>{{brew.abv}}%</i>
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  class="brew-card-footer row clearfix"
                  v-on:click="brew.isUnfolded = !brew.isUnfolded"
                >
                  <span v-if="brew.isUnfolded" class="mdi mdi-unfold-less-horizontal"></span>
                  <span v-else class="mdi mdi-unfold-more-horizontal"></span>
                  <div
                    class="brew-card-footer-extra-info row clearfix"
                    v-bind:class="{active:!brew.isUnfolded}"
                  >
                    <div v-if="brew.description">
                      <p>
                        <strong>Description</strong>
                      </p>
                      <p>{{brew.description}}</p>
                    </div>
                    <div v-if="brew.ingredients" style="margin-top:5px">
                      <p></p>
                      <p>
                        <strong>Ingredients</strong>
                      </p>
                      <p>{{brew.ingredients}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>


<script>
import LoadingComponent from "./Loading.vue";
import NoResultComponent from "./NoResult.vue";
import PageTitleComponent from "./PageTitle.vue";

import apiService from "./../services/apiService";
export default {
  name: "competition-summary-two",
  components: {
    LoadingComponent,
    NoResultComponent,
    PageTitleComponent
  },
  props: {
    competitionId: String
  },

  data() {
    return {
      isLoading: false,
      onlyCompetitionEntries: false,
      contestants: [],
      competition: null,
      sortByClass: true
    };
  },
  async created() {
    this.isLoading = true;
    try {
      await this.fetch();
    } catch (err) {
      console.log(err);
    } finally {
      this.isLoading = false;
    }
  },

  methods: {
    getClassLabel(classId) {
      var self = this;
      var c = this.competition.classes.find(function(element) {
        return element.id == classId;
      });
      if (c) {
        return c.name;
      } else return "No class";
    },
    getClassClass(classId) {
      var self = this;
      var c = this.competition.classes.find(function(element) {
        return element.id == classId;
      });
      if (c) {
        return c.cssClass;
      } else return "competition-class-black  tag";
    },
    async fetch() {
      const brewData = await apiService.getBrewsForCompetition(
        this.competitionId
      );

      brewData.data.forEach(function(c) {
        c.isUnfolded = false;
      });
      this.contestants = brewData.data;
      const competitionData = await apiService.getCompetition(
        this.competitionId
      );

      this.competition = competitionData.data;
    },
    toggle(row) {
      this.$refs.table.toggleDetails(row);
    },

    sortCompAsc(a, b) {
      if (a > b) return +1;
      if (a < b) return -1;
      return 0;
    },
    sortCompDesc(a, b) {
      if (a > b) return -1;
      if (a < b) return +1;
      return 0;
    }
  },

  computed: {
    computedContestants() {
      var self = this;

      var classesToShow = self.competition.classes.filter(
        c => c.showInList == true
      );

      var onlyForListing = this.contestants.filter(function(i) {
        if (
          classesToShow.some(
            c =>
              c.id === i.competitionClassId ||
              i.competitionClassId == undefined ||
              i.competitionClassId == "" ||
              i.competitionClassId == "00000000-0000-0000-0000-000000000000"
          )
        ) {
          return i;
        }
      });

      var filtered = onlyForListing.filter(function(i) {
        if (self.onlyCompetitionEntries) {
          return (
            i.competitionClassId != undefined && i.competitionClassId != "" && i.competitionClassId != "00000000-0000-0000-0000-000000000000"
          );
        } else {
          return i;
        }
      });

      var sorted = filtered;
      if (this.sortByClass) {
        sorted = filtered.sort(function(a, b) {
          return (
            self.sortCompDesc(
              self.getClassLabel(a.competitionClassId),
              self.getClassLabel(b.competitionClassId)
            ) || self.sortCompAsc(a.title, b.title)
          );
        });
      } else {
        sorted = filtered.sort(function(a, b) {
          return (
            self.sortCompAsc(a.brewer, b.brewer) ||
            self.sortCompDesc(
              self.getClassLabel(a.competitionClassId),
              self.getClassLabel(b.competitionClassId)
            ) ||
            self.sortCompAsc(a.title, b.title)
          );
        });
      }

      return sorted;
    }
  }
};
</script>
<style scoped>
div.brew-card {
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid #c5c5c5;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
  -moz-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
  -webkit-border-radius: 0px 15px 15px 0px;
  -moz-border-radius: 0px 15px 15px 0px;
  width: 100%; /* 360px !important;*/
  border-radius: 0px 15px 15px 0px;
  display: table;
  overflow: hidden;
  margin-bottom: 20px;
}

div.active {
  display: none;
  background-color: #ffffff;
}

div.competition-class-black {
  background-color: #494949 !important;
  color: #ffffff;
}

div.competition-class-yellow {
  background-color: #ffdd57;
  color: rgba(0, 0, 0, 0.7);
}
div.competition-class-blue {
  background-color: #167df0;
  color: #ffffff;
}

div.brew-card-header-class {
  border-radius: 0px !important;
  font-size: 0.75rem;
  width: 100%;
  border-left: 1px solid rgba(136, 145, 144, 0.6);
  height: 34px;
  text-align: center;
  vertical-align: middle;
}

div.brew-card-header {
  border-bottom: 1px solid rgba(136, 145, 144, 0.6);
  height: 35px;
  background-color: #f5f5f5;
  vertical-align: middle;
  overflow: auto;
}
div.brew-card-header-title {
  padding-top: 5px;
  padding-left: 10px;
}

div.brew-card-footer {
  clear: both;
  border-top: 1px dotted rgba(136, 145, 144, 0.6);
  background-color: #ffffff !important;
  padding: 0px;
  height: auto;
  display: block;
}
.clearfix::after {
  content: "";
  clear: both;
  display: table;
}

div.brew-card-footer-extra-info {
  clear: both;
  text-align: left;
  background-color: #ffffff !important;
  padding: 10px;
  height: auto;
}

div.brew-card-body {
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 10px;
}

.alignleft {
  width: 80%;
  float: left;
  text-align: left;
}

.alignright {
  width: 20%;
  float: right;
  text-align: right;
}
</style>